<div class="workspace app" [class.nav-open]="navOpen()">
  <header class="mobile-bar">
    <app-workspace-mobile-brand />
    <button
      type="button"
      class="mobile-bar__menu"
      (click)="toggleNav()"
      [attr.aria-expanded]="navOpen()"
      aria-label="Open navigation"
    >
      <lucide-icon [name]="navOpen() ? 'x' : 'menu'" [size]="22" [strokeWidth]="2.25" />
    </button>
  </header>

  <button type="button" class="nav-backdrop" *ngIf="navOpen()" (click)="closeNav()" aria-label="Close navigation"></button>

  <aside class="sidebar" aria-label="Enforcement navigation">
    <app-workspace-sidebar-brand
      moduleTag="Smart Building Check · Enforcement"
      (brandNavigate)="closeNav()"
    />

    <nav class="sidebar-nav" aria-label="Module sections">
      <div class="nav-group" *ngFor="let group of navGroups()" [class.nav-group--separator]="group.separatorBefore">
        <button
          type="button"
          class="nav-section-toggle"
          [class.nav-section-toggle--open]="isGroupExpanded(group.id)"
          [attr.aria-expanded]="isGroupExpanded(group.id)"
          (click)="toggleGroup(group.id)"
        >
          <span class="nav-section-title">{{ group.title }}</span>
          <lucide-icon
            class="nav-section-chevron"
            [name]="isGroupExpanded(group.id) ? 'chevron-down' : 'chevron-right'"
            [size]="16"
            [strokeWidth]="2.25"
          />
        </button>
        <div class="nav-group-items" *ngIf="isGroupExpanded(group.id)">
          <a
            *ngFor="let item of group.items"
            [routerLink]="item.path"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: item.path === '/enforcement/dashboard' }"
            (click)="closeNav()"
          >
            <lucide-icon class="nav-link-icon" [name]="item.icon" [size]="17" [strokeWidth]="2" />
            <span>{{ item.label }}</span>
          </a>
        </div>
      </div>
    </nav>

    <div class="sidebar-foot">
      <div class="session-card">
        <span class="session-dot" aria-hidden="true"></span>
        <div>
          <strong>{{ session.sidebarName() }}</strong>
          <small>{{ session.authorityLabel() }}</small>
        </div>
      </div>
      <a routerLink="/" class="sidebar-link" (click)="closeNav()">← Back to portal</a>
      <button type="button" class="logout-btn" (click)="logout()">Sign out</button>
    </div>
  </aside>

  <div class="workspace-main">
    <main class="page">
      <router-outlet />
    </main>
  </div>
</div>
